<template>
  <div id="knowledge-base-page ">
    <!-- JUMBOTRON -->
    <div class="knowledge-base-jumbotron">
      <div
        class="knowledge-base-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base"
        style="position: relative"
      >
        <h1 class="mb-1 text-white">{{ $t("baze") }}</h1>
        <!-- <p class="text-white">
          Bonbon sesame snaps lemon drops marshmallow ice cream carrot cake
          croissant wafer.
        </p> -->
        <vs-input
          v-model="formData.search"
          icon-no-border
          :placeholder="$t('system.search')"
          icon-pack="feather"
          icon="icon-search"
          size="large"
          @input="searchQuestions"
          class="w-full mt-6"
        />

        <vs-button
          v-if="checkRoleAdmin()"
          class="absolute"
          style="bottom: calc(1% + 20px); right: calc(1% + 20px)"
          @click="
            $router.push({
              name: 'help-admin',
            })
          "
          >{{ $t("create_new_category") }}
        </vs-button>
      </div>
    </div>

    <!-- KNOWLEDGE BASE CARDS  -->
    <div class="vx-row" v-if="questions.count">
      <div class="vx-col w-full md:w-2/5 lg:w-1/4">
        <vx-card title="Связанные вопросы">
          <ul class="bordered-items">
            <li v-for="que in questions.results" :key="que.id" class="py-2">
              <router-link
                :to="`/help/category/question/${$route.params.category}/${que.id}`"
                >{{ que.title }}
              </router-link>
            </li>
          </ul>
        </vx-card>
      </div>
    </div>

    <div v-else-if="questions.count == 0 && formData.search">
      <h5 class="text-center">{{ $t("no_data") }}</h5>
    </div>

    <div class="vx-row" v-else>
      <div
        class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base"
        v-for="item in GET_CATEGORY_LIST"
        :key="item.id"
        @click="
          $router.push({
            name: `help-category`,
            params: {
              category: item.id,
            },
          })
        "
      >
        <vx-card class="text-center cursor-pointer">
          <img
            v-if="item.image"
            :src="item.image"
            alt="graphic"
            width="180"
            height="180"
            class="mx-auto mb-4 pointer-events-none object-cover"
          />
          <div
            v-else
            class="mx-auto mb-4 flex items-center justify-center"
            style="width: 180px; height: 180px; background-color: #f8f8f8"
          >
            <feather-icon icon="ImageIcon" svgClasses="w-10 h-10" />
          </div>
          <h4 class="mb-2">{{ item.title.toUpperCase() }}</h4>
          <!-- <small>{{ item.description }}</small> -->
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { getUserData } from "@utils/auth"; // localstorage
export default {
  name: "Help",
  data() {
    return {
      initTimeOut: null,
      formData: { search: "" },
      questions: [],
    };
  },
  computed: {
    ...mapGetters("help", ["GET_CATEGORY_LIST"]),
  },

  mounted() {
    this.FETCH_CATEGORY_LIST();
  },
  methods: {
    ...mapActions("help", ["FETCH_CATEGORY_LIST", "FETCH_ALL_POST_LIST"]),

    searchQuestions() {
      let { search } = this.formData;
      if (!search) {
        this.questions = [];
        return;
      }
      clearTimeout(this.initTimeOut);
      this.initTimeOut = setTimeout(() => {
        this.FETCH_ALL_POST_LIST({ search }).then((r) => {
          this.questions = r.data;
        });
      }, 400);
    },

    checkRoleAdmin() {
      let { roles } = JSON.parse(getUserData());
      return Boolean(roles.find((el) => el.name === "admin"));
    },
  },
};
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
  background-image: url("../../assets/images/pages/knowledge-base-cover.jpg");
  background-size: cover;
}
</style>
